import { render, staticRenderFns } from "./EditProfilePage.vue?vue&type=template&id=347dbf2e&scoped=true"
import script from "./EditProfilePage.vue?vue&type=script&lang=js"
export * from "./EditProfilePage.vue?vue&type=script&lang=js"
import style0 from "./EditProfilePage.vue?vue&type=style&index=0&id=347dbf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347dbf2e",
  null
  
)

export default component.exports